<sc-socket-search
  (itemSelected)="selectCompany($event)"
  [displayFn]="displayFn"
  (search)="onSearch($event)"
  (clear)="clear.emit()"
  [selectedItem]="preSelected"
  [socketURL]="'Companies/SearchCompanies'"
  [inputRequired]="inputRequired"
  [floatingLabel]="floatingLabel"
  [placeholder]="customPlaceHolder ? customPlaceHolder : ('SEARCH_FOR_A_COMPANY' | translate)"
  errorMessage="{{ 'PLEASE_SELECT_A_COMPANY' | translate }}">
  <ng-template let-company>
    <div class="flex">
      <span class="search-option">
        @if (company.item.CompanyName) {
          <span [innerHTML]="company.item.CompanyName | highlight: company.searchInputCtrl.value"></span>
        }
        @if (company.item.Department) {
          <span
            [ngClass]="{ address: company.item.CompanyName }"
            [innerHTML]="company.item.Department | highlight: company.searchInputCtrl.value"></span>
        }
        @if (company.item.CompanyNumber) {
          <span
            [ngClass]="{ address: company.item.CompanyName }"
            [innerHTML]="company.item.CompanyNumber | highlight: company.searchInputCtrl.value"></span>
        }
        @if (company.item.ContactEmail) {
          <span
            [ngClass]="{
              address: company.item.CompanyName || company.item.ContactEmail
            }"
            [innerHTML]="company.item.ContactEmail | highlight: company.searchInputCtrl.value"></span>
        }
      </span>
    </div>
  </ng-template>
</sc-socket-search>
